// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2gBxm","text":"Loader_text__3KGIs","loaderAlertWrapper":"Loader_loaderAlertWrapper__1BSvI"};